import { IAdaptiveActionCard } from '@ninjacart/nc-nk-core';
import { IRemoteVideoMetadata } from '../interface/videoMetadataResponse';

export const transformAdaptiveToRemoteMetadata = (
  item: IAdaptiveActionCard
): IRemoteVideoMetadata => {
  const remoteMetadata: IRemoteVideoMetadata = {
    type:item?.type,
    id: item?.actionData?.content?.id,
    uuid: '',
    shortUUID: '',
    url: '',
    name: '',
    nsfw: false,
    truncatedDescription: item?.actionData?.content?.truncatedDescription,
    description: item?.actionData?.content?.description,
    isLocal: false,
    duration: item?.actionData?.content?.duration ?? 0,
    views: item?.actionData?.content?.viewsCount,
    viewers: 0,
    likes: item?.actionData?.content?.likesCount,
    dislikes: 0,
    thumbnailPath:
      item?.actionData?.mediaDetails?.[0]?.preview_url ??
      item?.actionData?.mediaDetails?.[0]?.mediaUrl,
    previewPath: item?.actionData?.mediaDetails?.[0]?.preview_url,
    embedPath: '',
    createdAt: item?.actionData?.content?.created_at,
    updatedAt: item?.actionData?.content?.created_at,
    publishedAt: item?.actionData?.content?.created_at,
    originallyPublishedAt: null,
    isLive: false,
    account: {
      url: '',
      name: item?.actionData?.content?.name,
      host: '',
      avatars: [],
      id: 0,
      hostRedundancyAllowed: false,
      followingCount: 0,
      followersCount: 0,
      createdAt: undefined,
      banners: [],
      displayName: item?.actionData?.content?.displayName ?? item?.actionData?.content?.name,
      description: null,
      updatedAt: undefined,
    },
    blacklisted: false,
    blacklistedReason: null,
    streamingPlaylists: [
      {
        id: item?.actionData?.content?.streamingPlaylistId ?? 0,
        playlistUrl: item?.actionData?.content?.streamingPlaylistUrl,
        type: 0,
        segmentsSha256Url: '',
        redundancies: [],
        files: [],
      },
    ],
    files: [],
    support: null,
    descriptionPath: '',
    tags: [],
    commentsEnabled: false,
    downloadEnabled: false,
    waitTranscoding: false,
    inputFileUpdatedAt: null,
    state: undefined,
    trackerUrls: [],
    userHistory: undefined,
    liked: false,
    likes_count: item?.actionData?.content?.likesCount,
    comments_count: item?.actionData?.content?.commentsCount,
    streamingPlaylistUrl: item?.actionData?.content?.streamingPlaylistUrl,
    streamingPlaylistId: item?.actionData?.content?.streamingPlaylistUrl,
    commentsCount: item?.actionData?.content?.commentsCount,
    likesCount: item?.actionData?.content?.likesCount,
    mediaDetails: [],
    viewsCount: item?.actionData?.content?.viewsCount,
    eventId: item?.actionData?.content?.eventId ?? '-1',
    postOwnerId: item?.actionData?.content?.postOwnerId,
    following: item?.actionData?.content?.following,
    avatar: '',
    created_at: new Date(),
    seoUrl: item?.actionData?.content?.seoUrl ?? item?.actionData?.content?.id,
    languageCode:item?.actionData?.content?.languageCode ?? 'en',
    title: item?.actionData?.content?.title ?? item?.actionData?.content?.description,
  };
  return remoteMetadata;
};
